import { useState } from 'react';
import { EditPrintTemplateDialog, LoadingExporting, ErpDataTableV2 } from '@/components/custom/erp';
import { BangKeHoaDonBanHangDichVuProvider, useBangKeHoaDonBanHangContext } from './context';
import { useDynamicSearch } from '@/hooks/use-dynamic-search';
import SearchDialog from './components/SearchDialog';
import DocumentForm from './components/DocumentForm';
import { invoiceReportColumns } from './columns';
import { useReport, useRows } from '@/hooks';
import { ActionBar } from './components';
import { QUERY_KEYS } from '@/constants';
import { useDialogState } from './hooks';

function BangKeHoaDonBanHangContent() {
  const { getReport, isLoading, data, currentPage, handlePageChange, totalItems } = useReport({
    endpoint: QUERY_KEYS.BANG_KE_HOA_DON_BAN_HANG,
    pageSize: 50
  });

  const {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,
    handleInitialSearch: handleInitialSearchHook,
    handleRefreshClick: handleRefreshClickHook,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleFixedColumnsClick,
    handleExportDataClick
  } = useDialogState();
  const { isExporting } = useBangKeHoaDonBanHangContext();
  const { handleRowClick, selectedObj, setSelectedObj } = useRows();
  const {
    searchState,
    handleSearchChange,
    handleSearchPageChange,
    hasFilterParams,
    handleInitialSearch,
    handleRefreshClick,
    isSearching
  } = useDynamicSearch({
    onSearch: getReport,
    params: searchParams,
    onInitialSearch: handleInitialSearchHook,
    getColumns: () => invoiceReportColumns(() => {}),
    endpoint: QUERY_KEYS.BANG_KE_HOA_DON_BAN_HANG,
    pageSize: 50
  });

  const [openDocumentForm, setOpenDocumentForm] = useState(false);
  const handleDocumentFormClick = (row: BanHangRecord) => {
    setSelectedObj(row);
    setOpenDocumentForm(true);
  };
  const resolvedRows = hasFilterParams ? searchState.searchResults : data;
  const resolvedCurrentPage = hasFilterParams ? searchState.currentPage : currentPage;
  const resolvedTotalItems = hasFilterParams ? searchState.totalCount : totalItems;
  const resolvedHandlePageChange = hasFilterParams ? handleSearchPageChange : handlePageChange;

  const tables = [
    {
      name: '',
      rows: resolvedRows || [],
      columns: invoiceReportColumns(handleDocumentFormClick)
    }
  ];

  return (
    <div className='flex h-screen w-screen flex-col lg:overflow-hidden'>
      {initialSearchDialogOpen && (
        <SearchDialog onClose={handleInitialSearchClose} onSearch={handleInitialSearch} initialValues={searchParams} />
      )}

      {openDocumentForm && selectedObj && (
        <DocumentForm
          document_uuid={selectedObj?.document_uuid}
          document_type={selectedObj?.document_type}
          onClose={() => setOpenDocumentForm(false)}
        />
      )}

      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {isExporting && <LoadingExporting />}

      {showTable && !openDocumentForm && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onPrintClick={() => {}}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            fromDate={searchParams.ngay_ct1 || ''}
            toDate={searchParams.ngay_ct2 || ''}
          />

          <div className='w-full overflow-hidden'>
            {!isLoading && (
              <ErpDataTableV2
                tables={tables}
                onRowClick={handleRowClick}
                totalItems={resolvedTotalItems}
                pageSize={50}
                currentPage={resolvedCurrentPage}
                onPageChange={resolvedHandlePageChange}
                loading={isLoading || isSearching}
                onSearchChange={handleSearchChange}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default function BangKeHoaDonBanHang() {
  return (
    <BangKeHoaDonBanHangDichVuProvider>
      <BangKeHoaDonBanHangContent />
    </BangKeHoaDonBanHangDichVuProvider>
  );
}
